/**
 * JSON Data Renderer with syntax highlighting
 * Feature: 073-job-queue-inspector
 *
 * Displays JSON data with basic syntax highlighting using CSS classes.
 */

interface JobDataRendererProps {
  data: any;
  label: string;
}

export function JobDataRenderer({ data, label }: JobDataRendererProps) {
  if (!data) {
    return (
      <div className="bg-gray-50 rounded-lg p-4">
        <p className="text-sm text-gray-500 italic">No {label.toLowerCase()} available</p>
      </div>
    );
  }

  // Pretty-print JSON with 2-space indentation
  const jsonString = JSON.stringify(data, null, 2);

  return (
    <div>
      <h4 className="text-sm font-medium text-gray-700 mb-2">{label}</h4>
      <div className="bg-gray-50 rounded-lg p-4 overflow-x-auto">
        <pre className="text-sm font-mono text-gray-800 whitespace-pre-wrap break-words">
          {jsonString}
        </pre>
      </div>
    </div>
  );
}
